<script setup lang="ts">
import ZendeskSupportFormLink from '@/components/session/kyc/supportLinks/ZendeskSupportFormLink.vue';
import GeneralSupportLink from '@/components/session/kyc/supportLinks/GeneralSupportLink.vue';

import { useKycSessionStore } from '@/stores/kycSession.store';
import { storeToRefs } from 'pinia';
import { config } from '@/config';
import { partnerConfigs } from '@/components/session/kyc/supportLinks/ZendeskPartnerSupportLink';

type issueType = 'kyc-timeout' | 'idv-error';

const props = defineProps<{
  issue?: issueType;
}>();

const reasonMap: Map<issueType, string> = new Map([
  ['kyc-timeout', 'KYC verification timeout'],
  ['idv-error', 'IDV error'],
]);

const reason = (props.issue && reasonMap.get(props.issue)) ?? 'kyc-timeout';

const { kycSession } = storeToRefs(useKycSessionStore());
const sessionId = kycSession.value?.id;
const cardholderId = kycSession.value?.cardholder.accountId;
const partnerName = config.errorPartnerNameOverride || kycSession.value?.partner?.name;
const normalizedPartnerName = partnerName?.trim()?.toLowerCase();
const isZendeskPartner = normalizedPartnerName && partnerConfigs.has(normalizedPartnerName);
</script>

<template>
  <ZendeskSupportFormLink
    :cardholder-id="cardholderId"
    :partner-name="normalizedPartnerName"
    :reason="reason"
    v-if="normalizedPartnerName && isZendeskPartner && cardholderId"
  />
  <GeneralSupportLink :correlation-id="sessionId" v-else />
</template>

<style scoped></style>
